import { MarkerType } from 'react-flow-renderer';
import {
    formatEntityTypeLabel,
    formatRelationEdgeLabel,
    getEntityNodeType,
} from 'src/modules/3rd-party-management/utils/shareholderGraph';

const nodePositions = (entities, relations, mainId) => {
    const main = { ...entities.find((e) => e.cin === mainId), x: 400, y: 300, xtype: 'main' };
    const shareholders = [];
    const subsidiaries = [];

    const entityMap = Object.fromEntries(entities.map((e) => [e.cin, e]));

    relations.forEach((r) => {
        if (r.to === mainId) {
            shareholders.push({
                ...entityMap[r.from],
                xtype: 'shareholder',
            });
        }

        if (r.from === mainId) {
            subsidiaries.push({
                ...entityMap[r.to],
                xtype: 'subsidiary',
            });
        }
    });

    shareholders.forEach((e, idx) => {
        e.x = 200 + idx * 200;
        e.y = 100;
    });

    subsidiaries.forEach((e, idx) => {
        e.x = 200 + idx * 200;
        e.y = 500;
    });

    return [main, ...shareholders, ...subsidiaries];
};

export const createGraphElements = (entities, relations, mainId, options = {}) => {
    const { t } = options;
    const positionedNodes = nodePositions(entities, relations, mainId);

    const nodes = positionedNodes.map((e) => {
        let backgroundColor = '#f5f5f5';
        let borderColor = '#999';

        if (e.xtype === 'main') {
            backgroundColor = '#1976d2';
            borderColor = '#1976d2';
        } else if (e.xtype === 'shareholder') {
            backgroundColor = '#388e3c';
            borderColor = '#4caf50';
        } else if (e.xtype === 'subsidiary') {
            backgroundColor = '#ff9800';
            borderColor = '#f57c00';
        }

        const nodeType = getEntityNodeType(e.type);

        return {
            id: e.cin,
            type: nodeType,
            data: {
                label: e.name,
                entityType: e.type || null,
                entityTypeLabel: formatEntityTypeLabel(e.type, t),
                additional_information: e.additional_information,
            },
            position: { x: e.x, y: e.y },
            style: {
                width: 180,
                padding: 10,
                textAlign: 'center',
                borderRadius: 10,
                border: `2px solid ${borderColor}`,
                backgroundColor,
                color: '#fff',
            },
        };
    });

    const edges = relations.map((r, idx) => ({
        id: `e${idx}`,
        source: r.from,
        target: r.to,
        label: formatRelationEdgeLabel(r, t),
        animated: true,
        markerEnd: { type: MarkerType.Arrow, color: '#555' },
        data: {
            type: r.type || null,
            percentage: typeof r.percentage === 'number' ? r.percentage : null,
        },
        style: {
            stroke: '#555',
            strokeWidth: 1.5,
        },
        labelStyle: { fill: '#333', fontWeight: 'bold' },
        labelBgStyle: { fill: '#fff', fillOpacity: 0.85 },
        labelBgPadding: [4, 2],
        labelBgBorderRadius: 4,
    }));

    return [nodes, edges];
};
